/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {
    Component,
    ContentChild,
    ElementRef,
} from '@angular/core';

import {IfOpenService} from '../../utils/conditional/if-open.service';
import {POPOVER_HOST_ANCHOR} from '../common/popover-host-anchor.token';

import {SignpostTriggerDirective} from './signpost-trigger.directive';
/**
 * ******
 * 
 * \@class Signpost
 * 
 * \@description 
 * Class used to configure and control the state of a Signpost and its associated SignpostContent.
 * It supports the clrPosition with a 'right-middle' default.
 * 
 */
export class Signpost {
/**
 * *******
 * \@property useCustomTrigger
 * 
 * \@description 
 * Flag used to determine if we need to use the default trigger or a user supplied trigger element.
 * 
 */
public useCustomTrigger: boolean = false;
/**
 * *******
 * \@property signPostTrigger
 * 
 * \@description 
 * Uses ContentChild to check for a user supplied element with the SignpostTriggerDirective on it.
 * 
 * @param {?} trigger
 * @return {?}
 */
set customTrigger(trigger: SignpostTriggerDirective) {
        this.useCustomTrigger = !!trigger;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-signpost",
    template: `
        <ng-container *ngIf="!useCustomTrigger">
            <button
                type="button"
                class="signpost-action btn btn-small btn-link"
                clrSignpostTrigger>
                <clr-icon shape="info"></clr-icon>
            </button>
        </ng-container>
        
        <ng-content></ng-content>
    `,
    host: {"[class.signpost]": "true"},
    providers: [IfOpenService, {provide: POPOVER_HOST_ANCHOR, useExisting: ElementRef}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'customTrigger': [{ type: ContentChild, args: [SignpostTriggerDirective, ] },],
};
}

function Signpost_tsickle_Closure_declarations() {
/** @type {?} */
Signpost.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Signpost.ctorParameters;
/** @type {?} */
Signpost.propDecorators;
/**
 * *******
 * \@property useCustomTrigger
 * 
 * \@description 
 * Flag used to determine if we need to use the default trigger or a user supplied trigger element.
 * 
 * @type {?}
 */
Signpost.prototype.useCustomTrigger;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
